<template>
  <client-only>
    <v-layout
      align-baseline
      mt-2
      mb-1
      pb-0
      class="align-vertical"
      :class="{ 'no-cv': AllowNoCV }"
    >
      <v-flex class="detail-item" :class="{ 'no-cv': AllowNoCV }">
        <p class="display-16 font-weight-medium text-align-center mb-0">
          {{ cvPopup.email }}
        </p>

        <span
          class="display-16 text-align-center email mb-0"
          :class="{ 'no-cv-email': AllowNoCV }"
        >
          {{ userProfile.Email }}
        </span>
      </v-flex>

      <v-flex class="detail-item" :class="{ 'no-cv': AllowNoCV }">
        <p class="display-16 font-weight-medium text-align-center mb-0">
          {{ cvPopup.phoneNum }}
        </p>

        <p class="display-16 mb-0">{{ phoneNum }}</p>
      </v-flex>

      <v-flex class="mobile-fields detail-item" :class="{ 'no-cv': AllowNoCV }">
        <p class="display-16 font-weight-medium text-align-center mb-0">
          {{ cvPopup.settlement }}
        </p>

        <p class="display-16 mb-0">{{ address }}</p>
      </v-flex>

      <v-flex class="mobile-fields detail-item" :class="{ 'no-cv': AllowNoCV }">
        <p class="display-16 font-weight-medium text-align-center mb-0">
          {{ cvPopup.lastPosition }}
        </p>

        <p class="display-16 mb-0">
          {{
            lastPosition === 'לא רלוונטי' || lastPosition === ''
              ? 'לא צוין'
              : lastPosition
          }}
        </p>
      </v-flex>

      <v-flex
        class="mobile-fields detail-item"
        :class="AllowNoCV ? 'no-cv' : 'border-none'"
      >
        <p class="display-16 font-weight-medium text-align-center mb-0">
          {{ cvPopup.experience }}
        </p>
        <p class="display-16 mb-0">{{ experience }}</p>
      </v-flex>

      <!-- <v-flex class="detail-item border-none">
        <p class="display-18 font-weight-medium text-align-center mb-0">
          {{ cvPopup.birthDate }}
        </p>

        <p class="display-18 mb-0">{{ birthYear }}</p>
      </v-flex> -->
    </v-layout>
  </client-only>
</template>

<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';
import CurrentUser from '@/components/mixins/CurrentUser';

export default {
  mixins: [CurrentUser],

  props: {
    AllowNoCV: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      cvPopup: t('titles.CV_Popup'),
    };
  },

  computed: {
    userProfile() {
      return this.CurrentUser;
    },

    phoneNum() {
      return this.userProfile &&
        this.userProfile.Profile &&
        this.userProfile.Profile.Phone
        ? this.userProfile.Profile.Phone
        : '';
    },

    address() {
      return this.userProfile &&
        this.userProfile.Profile &&
        this.userProfile.Profile.Location
        ? this.userProfile.Profile.Location.City
        : '';
    },

    lastPosition() {
      return this.userProfile &&
        this.userProfile.Profile &&
        this.userProfile.Profile.LastPosition
        ? this.userProfile.Profile.LastPosition
        : '';
    },

    experience() {
      return this.userProfile &&
        this.userProfile.Profile &&
        this.userProfile.Profile.Experience
        ? this.userProfile.Profile.Experience.Name
        : '';
    },

    birthYear() {
      return this.userProfile &&
        this.userProfile.Profile &&
        this.userProfile.Profile.BirthYear
        ? this.userProfile.Profile.BirthYear.toString()
        : '';
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.align-vertical {
  padding-bottom: 20px;
  border-radius: 5px;
  flex-direction: column;
  justify-content: space-between;
  align-items: start !important;
}

.align-vertical .flex p {
  display: inline-flex;
}

.text-align-center {
  text-align: center;
}

.border-primary {
  border-color: $primary;
}

.mobile-fields {
  display: inline;
}

.detail-item {
  padding: 0 10px;
  border-left: none;
}

/* jobs search */
@media only screen and (min-width: 920px) {
  .align-vertical {
    padding-bottom: 20px;
    border-radius: 5px;
    flex-direction: row;
    justify-content: space-between;
    &.no-cv {
      flex-wrap: wrap;
      width: 500px;
    }
  }

  .align-vertical .flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-height: 70px;
    justify-content: space-evenly;
    &.no-cv {
      align-items: start;
      min-height: auto;
    }
  }

  .align-vertical .flex p {
    text-align: center;
  }

  .border-primary {
    border-color: $primary;
  }
}
@media only screen and (min-width: 600px) {
  .detail-item {
    border-left: 1px solid $primary;
    &.no-cv {
      border-left: none;
      border-right: 1px solid $primary;
      margin-bottom: 15px;
      width: 50%;
      .no-cv-email {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        text-align: right;
      }
    }
  }
}
@media only screen and (max-width: 600px) {
  .display-18 {
    width: 100px;
  }
}
</style>
